import { Link, Navigate, Route, Routes } from 'react-router-dom';
import Queue from './pages/Queue.js';
import NewSpec from './pages/NewSpec.js';
import TrackDetail from './pages/TrackDetail.js';
import DropIdea from './pages/DropIdea.js';
import Dashboard from './pages/Dashboard.js';
import Activity from './pages/Activity.js';
import Security from './pages/Security.js';
import Engineering from './pages/Engineering.js';
import Settings from './pages/Settings.js';
import Conductor from './pages/Conductor/index.js';
import ThemedShell from './pages/Conductor/ThemedShell.js';
import Board from './pages/Conductor/Board.js';
import Login from './pages/Login.js';

function LegacyShellLayout() {
  return (
    <div className="shell">
      <div className="topbar">
        <h1>
          <Link to="/" style={{ textDecoration: 'none' }}>Conductor</Link>
        </h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <Link className="btn btn-outline" to="/dashboard">Dashboard</Link>
          <Link className="btn btn-outline" to="/security">Security</Link>
          <Link className="btn btn-outline" to="/engineering">Engineering</Link>
          <Link className="btn btn-outline" to="/drop-idea">+ Drop Idea</Link>
          <Link className="btn btn-primary" to="/new">+ New Spec</Link>
        </div>
      </div>
      <Dashboard />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Conductor />} />
      <Route path="/board" element={<Board />} />
      <Route path="/conductor" element={<Navigate to="/dashboard" replace />} />
      <Route path="/" element={<ThemedShell activeNav={null}><Queue /></ThemedShell>} />
      <Route path="/new" element={<ThemedShell activeNav={null}><NewSpec /></ThemedShell>} />
      <Route path="/drop-idea" element={<ThemedShell activeNav={null}><DropIdea /></ThemedShell>} />
      <Route path="/tracks/:id" element={<ThemedShell activeNav={null}><TrackDetail /></ThemedShell>} />
      <Route path="/activity" element={<ThemedShell activeNav="activity"><Activity /></ThemedShell>} />
      <Route path="/security" element={<ThemedShell activeNav="security"><Security /></ThemedShell>} />
      <Route path="/engineering" element={<ThemedShell activeNav="engineering"><Engineering /></ThemedShell>} />
      <Route path="/settings" element={<ThemedShell activeNav="settings"><Settings /></ThemedShell>} />
      <Route path="/dashboard-legacy" element={<LegacyShellLayout />} />
    </Routes>
  );
}
